module.exports = __webpack_public_path__ + "static/media/label-icon-white.4079700d.png";